import React, { useState, useEffect } from 'react'
import FinanceLayout from '../../../../../../layout/components/FinanceLayout'
import MonthlyDateSelect from '../../../../../../components/AppInput/MonthlyDateSelect';
import reportServices from '../reportServices';
import DashboardSummary from '../components/DashboardSummary';
import { Link } from 'react-router-dom';
import { DoubleArrow } from '@mui/icons-material';
import { CircularProgress } from '@mui/material';

function FinanceDashboardPage() {

  const [loading,setLoadingStatus] = useState(false);
  const [voucherList,setVoucherList] = useState();
  const [filter,setFilter] = useState(null);

  const getVoucherList =() =>{
    setLoadingStatus(true);
    reportServices.getFinalizedVoucherList(filter).then(res=>{
        setVoucherList(res.data);
    }).catch(error=>{
    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
      getVoucherList();
  },[filter])


  return (
    <FinanceLayout>
      
        <div className='row'>
            <div className='col-md-6'>
                <div className="bg-white p-2">
                  <Link to="/finance/report/daybook" className='btn btn-primary'> Open Daybook <DoubleArrow/> </Link>
                </div>
            </div>
            <div className='col-md-6 '>  
                <div className="bg-white p-2">
                <span className=''><MonthlyDateSelect filter={filter} setFilter={setFilter} /></span>
                </div>
            </div>
          </div>
          <div className='row mt-2'>
            <div className='col-md-12'>
              {loading ? 
                <div className='text-center mt-5'><CircularProgress/></div>
                :
                <DashboardSummary voucherList={voucherList} />
              }
              
            </div>
        </div>
      
    </FinanceLayout>
  )
}

export default FinanceDashboardPage